mutation RemoveOverwrites($campaignId: ID!, $overwriteIds: [ID]!) {
    removeOverwrites(campaignId: $campaignId, overwriteIds: $overwriteIds)
}
